import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useScrollCommentIntoView from "./useScrollCommentIntoView";
export default function useCommentFocus(hashToMatch) {
    const [focused, setFocused] = useState(false);
    const { hash  } = useLocation();
    const match = hashToMatch === hash;
    useEffect(()=>{
        if (match && !focused) setFocused(true);
        if (!match && focused) setFocused(false);
    }, [
        focused,
        match
    ]);
    const { ref  } = useScrollCommentIntoView(match);
    return {
        focused,
        ref
    };
};
